// https://github.com/vuejs/vuex/issues/833

import Vuex from 'vuex';

if (!Vuex.Store.prototype.hasModule) {
    Vuex.Store.prototype.hasModule = function(path) {
        return !!this._modules.root._children[path];
    };
}



// WEBPACK FOOTER //
// ./resources/assets/js/bootstrap/vuex.js